import React from 'react'
import clsx from 'clsx'
import Grid from '@mui/material/Grid'

import Button from 'components/Button'
import Typography from 'components/Typography'
import { useBreakpoint } from 'utils/Hooks'
import { route } from 'routes'

import stylesGlobal from 'stylesGlobal.module.scss'
import styles from './Banner.module.scss'

type BannerWelcomeProps = {
  className?: string
}

const BannerWelcome: React.FC<BannerWelcomeProps> = props => {
  const { className } = props
  const { isSmallscreenAbove } = useBreakpoint()

  return (
    <div className={clsx(styles.BannerWelcome, className)}>
      <Grid
        className={clsx(stylesGlobal.MarginXAuto, styles.BannerWelcomeContainer)}
        alignItems={isSmallscreenAbove ? 'center' : undefined}
        container
      >
        <Grid xs={12} sm item>
          <Typography
            variant="h5"
            component="h3"
            fontWeight="extraBold"
            className={stylesGlobal.MarginBottom4}
          >
            Welcome to Art Mine
          </Typography>

          <Typography variant="body1">
            Art Mine presents a collaborative way to create and experience art. Artists create
            generative AI models for you to mine and mint as NFTs. Each NFT is one-of-a-kind and can
            only be minted once.
            {/* Generate Art NFTs from artist-trained AI models by entering 8-digut codes.
            <br />
            Each artwork is unique, one-of-a-kind, and can only be sold once. */}
          </Typography>
        </Grid>

        <Grid
          xs={12}
          sm="auto"
          className={isSmallscreenAbove ? stylesGlobal.PaddingLeft72 : undefined}
          item
        >
          <Button
            className={clsx(
              !isSmallscreenAbove && stylesGlobal.MarginTop24,
              styles.ButtonOutlinedWhite
            )}
            variant="outlined"
            to={route.ABOUT.getUrl()}
          >
            Learn More
          </Button>
        </Grid>
      </Grid>
    </div>
  )
}

export default BannerWelcome
